import React, { Component } from 'react';
import { List, Header, Container } from 'semantic-ui-react';
import UrlHelper from '../../../url-helper';
import moment from 'moment';
import { Link } from 'react-router-dom';


class DetailsSection extends Component
{
    getHashLink( report )
    {
        const hash = report.data.pkg.hash;

        if( !hash )
        {
            return 'n/a';
        }

        return ( <a href={UrlHelper.getBitbucketCommitUrl( report, hash )} target='_blank'>{hash.substr( 0, 11 )}...</a> );
    }


   render()
    {
        const report = this.props.report;

        return (
            <Container className='Details'>
                <Header size={`large`}>Report Details</Header>
                <List>
                    <List.Item header={`Committed`} description={moment( report.data.pkg.committed ).format( 'YYYY-MM-DD hh:mm' )}></List.Item>
                    <List.Item header={`Generated`} description={moment( report.data.pkg.generated ).format( 'YYYY-MM-DD hh:mm' )}></List.Item>
                    <List.Item>
                        <List.Header>By</List.Header>
                        <List.Description>
                            <Link to={`mailto:${report.data.pkg.committerEmail}`}>{report.data.pkg.committerName}</Link>
                        </List.Description>
                    </List.Item>
                    <List.Item header={`Version`} description={report.data.pkg.version}></List.Item>
                    <List.Item header={`Hash`} description={this.getHashLink( report )}></List.Item>
                    <List.Item header={`Tag`} description={report.data.pkg.tag || 'n/a'}></List.Item>
                </List>
            </Container>
        );
    }
}

export default DetailsSection;




// WEBPACK FOOTER //
// ./src/lib/components/PackageView/Sections/Details.js